import {createContext} from "../../../__snowpack__/pkg/react.js";
export const RichTextEditorContext = createContext({editorState: void 0});
